import React from 'react';
import { Link } from 'react-router-dom';
import { removeLastPart } from '../../../lib/route.utils';
import Button from '../../../components/forms/Button';
import DropdownMenu from '../../forms/DropdownMenu';
import { getText } from '../../../constants/admin/texts';

const DetailsButtons = props => (
    <div className="ckp-admin-forms-buttons">
        {props.editButton ? null : props.onCancel ? (
            <a className="ckp-buttons-text is-warning" onClick={props.onCancel}>
                Cancel
            </a>
        ) : (
            <Link
                className="ckp-buttons-text is-warning"
                to={removeLastPart(props.currentPath, props.subContext ? 2 : 1)}
            >
                Cancel
            </Link>
        )}
        {props.dropdown ? (
            <DropdownMenu
                label="More"
                disabled={props.dropdown.disabled}
                options={props.dropdown.options}
                selectFunctions={props.dropdown.functions}
            />
        ) : null}
        <Button
            type="button"
            inactive={props.editButton ? false : !props.edited || !props.canSubmit}
            onClick={props.editButton ? props.onEdit : props.onSubmit}
            className="is-auto-width"
            label={props.editButton ? getText(props.model, 'detailsEdit') : getText(props.model, 'detailsSave')}
        />
    </div>
);

export default DetailsButtons;



// WEBPACK FOOTER //
// ./src/components/admin/forms/DetailsButtons.js